import React from 'react';

/**
 * RouteTransition - Simplified wrapper that renders children directly
 * without fade animations to avoid jarring visual transitions.
 */
export default function RouteTransition({ children }) {
  return <>{children}</>;
}
